import { instance } from 'utils/api';

// POST /contact-us body — the DTO is camelCase (legacy GQL input was
// snake_case) and phoneNumber/description are required.
export type ContactUsPayload = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber: string;
  description: string;
  recaptchaToken?: string;
};

export const sendContactUs = (payload: ContactUsPayload) =>
  instance.post('contact-us', payload);
